import Vue from 'vue';
import Vuex from 'vuex';

import config from '../setup/config';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

Vue.use(Vuex);

const state = {
  sidenavCollapsed: false,
  microserviceToken: null,
  whizeoToken: null,
  userInfo: null,
  clientInfo: null,
  showTutorial: false,
  theme: 'light-theme',
};

export default new Vuex.Store({
  strict: config.isDevelopment,
  state,
  actions,
  mutations,
  getters,
});
